export { default } from './DestinationAccordion'
